export default __webpack_public_path__ + "static/media/lockedunicorncloud_trans2.00e21446.png";